// presenceStreamExclusiveChannelHandler.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe presence stream exclusive channel.
 * @kind action
 * @param {string} {streamId} - livestream id.
 * @param {boolean} {isSubscribe} - subscribe or unsubscribe.
 * @return {Promise} Action promise.
 */
const presenceStreamExclusiveHandler =
  ({ streamId, isSubscribe } = {}) =>
  async dispatch => {
    if (!streamId) return dispatch({ type: '' });
    return sendMessageToSW({
      type: isSubscribe
        ? MessageTypes.SUBSCRIBE_PRESENCE_STREAM_EXCLUSIVE_CHANNEL
        : MessageTypes.UNSUBSCRIBE_PRESENCE_STREAM_EXCLUSIVE_CHANNEL,
      payload: {
        streamId,
      },
    });
  };

/**
 * Subscribe presence stream exclusive channel.
 * @kind action
 * @param {string} {streamId} - livestream id.
 * @return {Promise} Action promise.
 */
export const subscribePresenceStreamExclusive =
  ({ streamId } = {}) =>
  async dispatch => {
    dispatch(presenceStreamExclusiveHandler({ streamId, isSubscribe: true }));
  };

/**
 * Unsubscribe presence stream exclusive channel.
 * @kind action
 * @param {string} {streamId} - livestream id.
 * @return {Promise} Action promise.
 */
export const unsubscribePresenceStreamExclusive =
  ({ streamId } = {}) =>
  async dispatch => {
    dispatch(presenceStreamExclusiveHandler({ streamId, isSubscribe: false }));
  };
